<form (ngSubmit)="onFormSubmit()" #f="ngForm">
    <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Close click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body pt-md-5 pb-md-5">
        <div class="form-group row mb-0 pt-2 pb-2">
            <label class="col-md-4 col-form-label">Personal Goal:</label>
            <div class="col-md-8">

                <div class="input-group">
                    <div class="input-group-prepend full-width">
                        <span class="input-group-text">
                            <i class="fa fa-dollar"></i>
                        </span>

                        <input class="form-control ui-input-personal-goal"
                               name="individualGoal"
                               [ngClass]="{'ng-invalid': individualGoalErrorMessage}"
                               [(ngModel)]="individualGoal"
                               currencyMask
                               (ngModelChange)="onIndividualGoalChange($event)"
                               [options]="{allowNegative: false, precision: 0}"
                               placeholder="Enter Dollar Amount">

                        <div class="form-control-error"
                             *ngIf="individualGoalErrorMessage">
                            <ul>
                                <li>{{individualGoalErrorMessage}}</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="form-group row mb-0 pt-2 pb-2"
             *ngIf="!settingGoalForFacebook && (eventService?.selectedEvent?.gql?.Participant[0]?.team?.teamId &&
			 (eventService?.selectedEvent?.gql?.Participant[0]?.teamRoleType?.name === 'CAPTAIN' || 
				eventService?.selectedEvent?.gql?.Participant[0]?.teamRoleType?.name === 'CANDIDATE' ||
				eventService?.selectedEvent?.gql?.Participant[0]?.teamRoleType?.name === 'HONORED_CANDIDATE_F' ||
				eventService?.selectedEvent?.gql?.Participant[0]?.teamRoleType?.name === 'MWOY_ALL_STAR')) ">
            <label class="col-md-4 col-form-label" *ngIf="eventService?.selectedEvent?.cssClass === 'program-s2'">Class Goal:</label>
            <label class="col-md-4 col-form-label" *ngIf="eventService?.selectedEvent?.cssClass !== 'program-s2'">Team Goal:</label>
            <div class="col-md-8">
                <div class="input-group">
                    <div class="input-group-prepend full-width">
                        <span class="input-group-text">
                            <i class="fa fa-dollar"></i>
                        </span>

                        <input class="form-control money-mask-input ui-input-team-goal"
                               name="teamGoal"
                               [(ngModel)]="teamGoal"
                               currencyMask
                               [ngClass]="{'ng-invalid': teamGoalErrorMessage}"
                               (ngModelChange)="onTeamGoalChange($event)"
                               [options]="{allowNegative: false, precision: 0}"
                               placeholder="Enter Dollar Amount">

                        <div class="form-control-error"
                             *ngIf="teamGoalErrorMessage">
                            <ul>
                                <li>{{teamGoalErrorMessage}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Save</button>
    </div>
</form>
